import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Glyphicon, Nav, Navbar, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import './NavMenu.css';
import * as appsettings from './constants';
export class NavMenu extends Component {
    displayName = NavMenu.name
    render() {
        return (
            <Navbar inverse fixedTop fluid collapseOnSelect>
                <Navbar.Header>
                    <Navbar.Brand>
                        <Link to={'/'} >{appsettings.WebsiteHeader_1}<br />{appsettings.WebsiteHeader_2}</Link>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav>
                        <LinkContainer to={'/HourlyView'}>
                            <NavItem>
                                <Glyphicon glyph='th-list' /> {appsettings.HourlyViewHeader}
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer to={'/'} exact >
                            <NavItem>
                                <Glyphicon glyph='th-list' /> {appsettings.DailyViewHeader}
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer to={'/WeeklyView'}>
                            <NavItem>
                                <Glyphicon glyph='th-list' /> {appsettings.WeeklyViewHeader}
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer to={'/MonthlyView'}>
                            <NavItem>
                                <Glyphicon glyph='th-list' /> {appsettings.MonthlyViewHeader}
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer to={'/GetKPIs'}>
                            <NavItem>
                                <Glyphicon glyph='th-list' /> {appsettings.CustomViewHeader}
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer to={'/MonthlySummary'}>
                            <NavItem>
                                <Glyphicon glyph='th-list' /> {appsettings.MonthlySummaryHeader}
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer to={'/EngineeringDetails'}>
                            <NavItem>
                                <Glyphicon glyph='th-list' /> {appsettings.EngineeringDetailsHeader}
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer to={'/CommentView'}>
                            <NavItem>
                                <Glyphicon glyph='th-list' /> {appsettings.CommentViewHeader}
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer to={'/About'}>
                            <NavItem>
                                <Glyphicon glyph='th-list' /> {appsettings.AboutHeader}
                            </NavItem>
                        </LinkContainer>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}
